import { render, staticRenderFns } from "./curvaPrescritores.vue?vue&type=template&id=6783ebf3"
import script from "./curvaPrescritores.ts?vue&type=script&lang=js&external"
export * from "./curvaPrescritores.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6783ebf3')) {
      api.createRecord('6783ebf3', component.options)
    } else {
      api.reload('6783ebf3', component.options)
    }
    module.hot.accept("./curvaPrescritores.vue?vue&type=template&id=6783ebf3", function () {
      api.rerender('6783ebf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/curvaABC/curvaPrescritores.vue"
export default component.exports